import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons/faUpRightFromSquare';
import { Text, TextType } from 'ui-components/components/text';
import { HelpArticleLink } from '../../../../components/help-article-link/index';
import { linkIDs } from '../../../../services/link-service/links';
import { messages } from '../messages';
import styles from './style.module.css';

export const WindsorFrameworkPopoverContent = () => {
  return (
    <div className={styles['popover-content']}>
      <Text className={styles['popover-title']} textType={TextType.Caption} value={messages.windsorFrameworkPopoverTitle} />
      <Text className={styles['popover-body']} textType={TextType.Caption} value={messages.windsorFrameworkPopoverContent} />
      <div className={styles['popover-footer']}>
        <HelpArticleLink articleId={linkIDs.WindsorFrameworkDetails} className={styles['external-link']}>
          <Text textType={TextType.Caption} value={messages.windsorFrameworkPopoverLinkText} />
          <FontAwesomeIcon className={styles['external-link-icon']} icon={faUpRightFromSquare} />
        </HelpArticleLink>
      </div>
    </div>
  );
};
